module.exports = __webpack_public_path__ + "img/shortcode_hifi_5.41d58dae.png";